import themeVariables from "@/config/theme/themeVariable";
import Link from "next/link";
import Image from "next/image";
import { BLUR_URL, images } from "@/utils/images";
import { BlogItem } from "../types";
import { getLanguage } from "@/utils/localStorageControl";

export default function BlogCard({ blog }: { blog: BlogItem }) {
  const language = getLanguage();
  
  return (
    <Link href={`/blogs/${blog.id}`}>
      <div className="group cursor-pointer">
        <div className="mb-4 overflow-hidden rounded-xl relative h-48 sm:h-52 md:h-48 lg:h-48">
          <Image 
            src={blog.thumbnail} 
            alt={blog.data['en'].title}
            fill
            className="object-cover group-hover:scale-105 transition-transform duration-300"
            placeholder="blur"
            blurDataURL={BLUR_URL}
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          />
        </div>
        <div className="text-sm text-gray-500 mb-2">
          {new Date(blog.createdAt).toLocaleDateString()}
        </div>
        <h3 className="font-semibold text-gray-900 mb-2 group-hover:text-gray-600 transition-colors break-words">
          {blog.data[language]?.title}
        </h3>
        <div className="flex flex-wrap gap-1">
          {blog.data[language]?.tags && blog.data[language]?.tags?.map((tag: string) => (
            <span key={tag} className={`${themeVariables.badge.light} text-xs`}>
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}
